<template>
  <div>
    <p> {{ this.statusServer }}</p>
<!--    <input type="text" v-model="username" placeholder="username">-->
<!--    <input type="text" v-model="password" placeholder="password">-->
<!--    <button @click.prevent="testServer()">Test Server</button>-->
<!--    <button @click.prevent="getToken()">Get Token</button>-->
    <button @click.prevent="sendEmail()">Test</button>
    <pre>
            {{response }}
        </pre>
  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    // import MainFormMember from './MainFormMember.vue'
    // import FormLicenceMember from './FormLicenceMember'
    import ListSelectClub from './Communs/listeSelectClub'
    import GoogleMap from './Communs/googleMap'
    import VueNoty from 'vuejs-noty'

    var _ = require('underscore')

    export default {
        data() {
            return {
                response: "",
                statusServer: "",
                // Jamais d'identifiants en dur : ce composant est compilé dans
                // app.js, servi publiquement. Les champs du formulaire ci-dessus
                // sont à décommenter pour saisir de quoi tester.
                username: "",
                password: ""
            }
        },
        props: {
            // club: Object
        },
        mounted: function () {
            this.$noty.success('Youhou!')
            // this.loadClub();
            this.$nextTick(function () {
            })
        },
        computed: {
            ...mapGetters({
                getMember: 'getMember',
                getMainUser: 'getMainUser'
            })
        },
        methods: {
            ...mapActions({
                setMainUser: 'setMainUser'
            }),
            sendEmail: function () {
                try {
                    var theApp = new ActiveXObject("Outlook.Application");
                    var objNS = theApp.GetNameSpace('MAPI');
                    var theMailItem = theApp.CreateItem(0); // value 0 = MailItem
                    theMailItem.to = ('test@gmail.com');
                    theMailItem.Subject = ('test');
                    theMailItem.Body = ('test');
                    theMailItem.Attachments.Add("C\\file.txt");
                    theMailItem.display();
                } catch (err) {
                    alert(err.message);
                }
            },

            getToken: function () {
                let these = this;
                this.response = "";
                this.$http.post("requestToken", {
                    "username": these.username,
                    "password": these.password,
                }).then(resp => {
                    these.response = resp.body
                }, (resp) => {
                    these.response = resp.body
                })
            },
            testServer: function () {
                let these = this;
                this.response = "";

                this.$http.get("testServer").then(resp => {
                    these.statusServer = resp.body
                }, (resp) => {
                    these.statusServer = resp.body
                })
            },
            TestApi: function () {
                let these = this;
                this.response = "";

                this.$http.get("api/testApi").then(resp => {
                    these.response = resp.body
                }, (resp) => {
                    these.response = resp.body
                })
            }
        },

        components: {
            GoogleMap,
            ListSelectClub,
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/AppTest.vue